import type { ApplicationsDropdownProps } from 'features/ContactSidebar/ApplicationsDropdown/ApplicationsDropdown.types';
import { Listbox, Transition } from '@headlessui/react';
import { AlertIcon, ArrowDownIcon } from 'icons/outline';
import clsx from 'clsx';
import { useContext } from 'react';
import { ContactSidebarContext } from '../ContactSidebarContext';

export const ApplicationsDropdown = (props: ApplicationsDropdownProps) => {
  const ctx = useContext(ContactSidebarContext);

  const { otherJobApplications } = ctx;

  if (!otherJobApplications || otherJobApplications.length === 0) {
    return null;
  }

  return (
    <Listbox as="div" className="relative z-[1]" role="combobox">
      {({ open }) => (
        <div className="relative">
          <Listbox.Button
            className={clsx(
              'flex items-center justify-between w-full px-2 h-7 text-sm text-neutral-dark border border-neutral rounded-[4px] focus:outline-none focus-visible:ring focus-visible:ring-gray-500 focus-visible:ring-opacity-75',
              {
                'bg-neutral-no-white hover:bg-tertiary-blue-200': !open,
                'bg-tertiary-blue-200': open,
              },
            )}
          >
            <div className="flex items-center justify-start gap-1">
              <AlertIcon className="h-4 w-4" />
              Also applied to{' '}
              <span className="font-bold">{otherJobApplications.length} other roles</span>
            </div>

            <ArrowDownIcon
              className={clsx('h-4 w-4 text-primary-poppy-red transform transition-transform', {
                'rotate-180': open,
              })}
            />
          </Listbox.Button>

          <Transition
            show={open}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Listbox.Options className="absolute top-full mt-1.5 left-0 right-0 max-h-[200px] overflow-auto shadow-alert p-2 text-sm text-neutral-ink-blue bg-neutral-full-white border border-neutral-light rounded-md divide-y divide-neutral-light">
              {otherJobApplications.map((jobApplication, i) => {
                return (
                  <Listbox.Option
                    key={jobApplication.id}
                    value={jobApplication.id}
                    className="p-2 rounded-md hover:bg-neutral-no-white"
                  >
                    <p>{jobApplication.jobListing().title}</p>
                    <p className="text-neutral-dark">
                      Applied on {jobApplication.formattedAppliedAt()}
                    </p>
                  </Listbox.Option>
                );
              })}
            </Listbox.Options>
          </Transition>
        </div>
      )}
    </Listbox>
  );
};

ApplicationsDropdown.displayName = 'ApplicationsDropdown';
